import { CircularProgress } from '@mui/material';
import React from 'react';
import { SxProps } from '@mui/material';

const LoadingIndicator = ({ sx }: { sx?: SxProps }): JSX.Element => (
  <CircularProgress
    id="LoadingIndicator"
    size={24}
    sx={{ display: 'block', margin: '12px auto', color: '#668098', ...sx }}
  />
);

export default LoadingIndicator;
